<div class="popup">
	<div class="popup-header">
		<h1>
			{{'SICK_DAY.ANSWER' | translate}}
		</h1>
		<qo-icon
			[icon]="EQORebrandIcon.trash_dark"
			[invertedScheme]="true"
			[scheme]="EQORebrandColor.SECONDARY"
			[color]="EQORebrandColor.SECONDARY"
			[size]="'sm'"
			(click)="close()"
		></qo-icon>
	</div>
	<div class="popup-body">
		<div class="qo-padding30  qo-flex-row-space-between">
			<div class="qo-flex-row-top-left">
				<qo-profile-image
					[imageUrl]="data.sickDay?.shift.user.profile_picture?.download_url"
					[letter]="data.sickDay?.shift.user.getInitials()"
					[size]="40"
					[fontSize]="20"
				></qo-profile-image>
				<div class="qo-flex-col-top-left qo-margin-left20">
					<h4>{{data.sickDay?.shift.user.getFullName()}}</h4>
					<div class="qo-flex-row-top-left qo-margin-top10 align-center">
						<qo-icon
							[icon]="EQORebrandIcon.sick_dark_filled"
							[invertedScheme]="true"
							[scheme]="EQORebrandColor.NO"
							[color]="EQORebrandColor.NO"
							[size]="'sm'"
						></qo-icon>
						<div class="qo-margin-left10 qo-no">{{'SICK_DAY.SICK' | translate}}</div>
					</div>
				</div>
				<div class="qo-flex-col-top-right">
					<div>{{data.sickDay?.shift.start.format('DD/MM/YYYY')}}</div>
					<div class="qo-margin-top10">
						{{data.sickDay?.shift.start.localDate.format('HH:mm')}}
						- {{data.sickDay?.shift.end.localDate.format('HH:mm')}}</div>
				</div>
			</div>
		</div>
		<div class="qo-flex-col-top-left">
			<div class="qo-flex-row-space-between qo-padding30">
				<h4>
					{{'EMPLOYEES.DEPARTMENT' | translate}}
				</h4>
				<div>{{data.sickDay.shift.department.department_name}}</div>
			</div>
			<div class="qo-flex-row-space-between qo-padding30 grey">
				<h4>
					{{'GLOBAL.GROUP' | translate}}
				</h4>
				<div>{{data.sickDay.shift.group.group_name}}</div>
			</div>
			<div class="qo-flex-row-space-between qo-padding30">
				<h4>
					{{'GLOBAL.PAUSE' | translate}}
				</h4>
				<div>{{data.sickDay.shift.pause}}</div>
			</div>
			<div class="qo-flex-row-space-between qo-padding30 grey">
				<h4 class="qo-padding-right30 qo-flex-row-top-left">
					{{'SCHEDULE.NOTE' | translate}}
				</h4>
				<div class="qo-flex-col-top-right break-words">{{data.sickDay.message}}</div>
			</div>
		</div>
	</div>
	<div class="qo-flex-row-top-right qo-padding30 mobile-absolute">
		<button
			class="qo-button-standard qo-white"
			(click)="respond(false)"
		>
			<qo-icon [icon]="EQORebrandIcon.trash_dark" [size]="'sm'"></qo-icon>
			{{ 'SICK_DAY.CAN_NOT_TAKE' | translate }}
		</button>
		<button
			class="qo-button-standard qo-primary qo-margin-left30"
			[class.qo-button-loader]="isLoading$ | async"
			(click)="respond(true)"
		>
			<qo-icon [icon]="EQORebrandIcon.checkmark_dark" [size]="'sm'" [color]="EQORebrandColor.WHITE"></qo-icon>
			{{ 'SICK_DAY.CAN_TAKE' | translate }}
		</button>
	</div>
</div>
